import { Box, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarBorder from "@mui/icons-material/StarBorder";
import NirantaraIcon from "../assets/images/vajra.svg";
import {
  miniSidebarElements,
  sidebarElements1,
  sidebarElementsFacility,
} from "../utils/constant";
import scopeoverview from "../assets/images/Sidebar/scopeoverview.svg";
import purchasegoods from "../assets/images/Sidebar/purchasegoods.svg";
import upstreamleasedassets from "../assets/images/Sidebar/UpstreamLeasedAssets.svg";
import wastegenerated from "../assets/images/Sidebar/wastegenerated.svg";
import businesstravel from "../assets/images/Sidebar/businesstravel.svg";
import transportmaster from "../assets/images/Sidebar/transportmaster.svg";
import capitalGoodsIcon from "../assets/images/Sidebar/capitalGoodsIcon.svg";
import processingOfSoldProductsIcon from "../assets/images/Sidebar/ProcessingOfSoldProducts.svg";
import EOLTreatementIcon from "../assets/images/Sidebar/EOLTreatementIcon.svg";
import downstreamLeasedAssetsIcon from "../assets/images/Sidebar/downstreamLeasedAssets.svg";
import franchisesIcon from "../assets/images/Sidebar/Franchises.svg";
import investmentsIcon from "../assets/images/Sidebar/InvestmentIcon.svg";
import UseOfSoldProductsIcon from "../assets/images/Sidebar/UseOfSoldProducts.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import SidebarItemsRenderer from "../utils/layoutFunctions";
import { useUser } from "../context/AuthContext";
import {
  filterMiniSidebarElements,
  getRoleBasedSidebar,
} from "../utils/sidebarFunctions";

const scope3MastersSidebarElements = [
  {
    text: "Overview",
    icon: scopeoverview,
    path: "/scope3/dashboard",
  },
  {
    text: "Purchased Goods and Services",
    icon: purchasegoods,
    path: "",
    moduleName: "Environment | Scope 3 | Purchased goods & services",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/purchased-goods/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/purchased-goods/emissions",
      },
    ],
  },
  {
    text: "Capital Goods",
    icon: capitalGoodsIcon,
    path: "",
    moduleName: "Environment | Scope 3 | Captial Goods",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/capital-goods/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/capital-goods/emission",
      },
    ],
  },
  {
    text: "Transportation and Distribution",
    icon: transportmaster,
    path: "",
    moduleName: "Environment | Scope 3 | Transportation distribution",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/transportation/dashboard",
      },
      {
        text: "Road Transportation",
        icon: StarBorder,
        path: "/scope3/transportation/road",
      },
      {
        text: "Air Transportation",
        icon: StarBorder,
        path: "/scope3/transportation/air",
      },
      {
        text: "Rail Transportation",
        icon: StarBorder,
        path: "/scope3/transportation/rail",
      },
      {
        text: "Ship Transportation",
        icon: StarBorder,
        path: "/scope3/transportation/ship",
      },
    ],
  },
  {
    text: "Waste Generated in Operations",
    icon: wastegenerated,
    path: "",
    moduleName: "Environment | Scope 3 | Waste generated",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/waste-generated/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/waste-generated/operation",
      },
    ],
  },
  {
    text: "Business Travel",
    icon: businesstravel,
    path: "",
    moduleName: "Environment | Scope 3 | Business travel",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/business-travel/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/business-travel/emission",
      },
    ],
  },
  {
    text: "Employee Commute",
    icon: purchasegoods,
    path: "",
    moduleName: "Environment | Scope 3 | Employee commute",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/employee-commute/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/employee-commute",
      },
    ],
  },
  {
    text: "Upstream Leased Assets",
    icon: upstreamleasedassets,
    path: "",
    moduleName: "Environment | Scope 3 | Upstream Leased Assets",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/upstream-leased-assets/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/upstream-leased-assets",
      },
    ],
  },
  {
    text: "Processing of Sold Products",
    icon: processingOfSoldProductsIcon,
    path: "",
    moduleName: "Environment | Scope 3 | Processing of Sold Products",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/processing-of-sold-products/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/processing-of-sold-products",
      },
    ],
  },
  {
    text: "Use of Sold Products",
    icon: UseOfSoldProductsIcon,
    path: "",
    moduleName: "Environment | Scope 3 | Use of Sold Products",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/use-of-sold-products/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/use-of-sold-products",
      },
    ],
  },
  {
    text: "End of Life Treatment of Sold Products",
    icon: EOLTreatementIcon,
    path: "",
    moduleName: "Environment | Scope 3 | End of Life Treatment of Sold Products",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/eol-treatment-of-sold-products/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/eol-treatment-of-sold-products",
      },
    ],
  },
  {
    text: "Downstream Leased Assets",
    icon: downstreamLeasedAssetsIcon,
    path: "",
    moduleName: "Environment | Scope 3 | Downstream Leased Assets",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/downstream-leased-assets/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/downstream-leased-assets",
      },
    ],
  },
  {
    text: "Franchises",
    icon: franchisesIcon,
    path: "",
    moduleName: "Environment | Scope 3 | Franchises",
    children: [
      {
        text: "Overview",
        icon: StarBorder,
        path: "/scope3/franchises/dashboard",
      },
      {
        text: "Data",
        icon: StarBorder,
        path: "/scope3/franchises",
      },
    ],
  },
  // {
  //   text: "Investments",
  //   icon: investmentsIcon,
  //   path: "",
  //   moduleName: "Environment | Scope 3 | Investments",
  //   children: [
  //     {
  //       text: "Overview",
  //       icon: StarBorder,
  //       path: "/scope3/investments/dashboard",
  //     },
  //     {
  //       text: "Data",
  //       icon: StarBorder,
  //       path: "/scope3/investments",
  //     },
  //   ],
  // },
];

const Scope3Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const { user } = useUser();

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    if (!sidebarEl) return;

    const handleScroll = () => {
      localStorage.setItem("sidebarScrollTop", sidebarEl.scrollTop);
    };

    sidebarEl.addEventListener("scroll", handleScroll);

    return () => {
      sidebarEl.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    const savedScrollTop = localStorage.getItem("sidebarScrollTop");

    if (sidebarEl && savedScrollTop) {
      sidebarEl.scrollTop = parseInt(savedScrollTop, 10);
    }
  }, []);

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = sidebarElements.map((item) => {
    if (item.path === "/production-revenue") {
      return {
        ...item,
        heading: user?.companyAdmin ? "Production & Revenue" : "Production",
      };
    }
    if (item.heading === "Setup" && item.subData) {
      const newSubData = item.subData.filter(
        (sub) => sub.primary !== "Facility Master" || !user?.facility,
      );
      return { ...item, subData: newSubData };
    }
    return item;
  });

  const miniSidebarFiltered = filterMiniSidebarElements({
    user,
    miniSidebarElements,
  });

  const filteredScope3MastersSidebarElements = useMemo(() => {
    const bypassFilter =
      !user?.modules ||
      user?.facilityManger ||
      user?.companyAdmin;
    if (bypassFilter && !(user?.isSubCompanyAdmin && user?.modules)) {
      return scope3MastersSidebarElements;
    }
    return scope3MastersSidebarElements.filter((item) => {
      return !item.moduleName || user.modules.includes(item.moduleName);
    });
  }, [
    user?.modules,
    user?.facilityManger,
    user?.companyAdmin,
    user?.isSubCompanyAdmin,
  ]);

  const [open, setOpen] = useState(() => {
    const activeHeader = filteredScope3MastersSidebarElements.find((item) =>
      item.children?.some((child) => child.path === location.pathname),
    );
    return activeHeader
      ? {
          index: filteredScope3MastersSidebarElements.indexOf(activeHeader),
          header: activeHeader.text,
        }
      : {};
  });

  const handleClick = (item, index) => {
    setOpen((prevOpen) =>
      prevOpen.index === index ? {} : { index, header: item.text },
    );
  };

  const renderMainSidebarItems = (elements) => {
    return elements.map((item, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          marginTop: "0.25rem",
        }}
      >
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              item.primary === "Scope 1" ? "#488257" : "transparent",
          }}
        >
          <Tooltip
            title={item.title}
            arrow
            placement="bottom-start"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#fff",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "0.25rem 0.5rem",
                },
                arrow: {
                  color: "#fff",
                },
              },
            }}
          >
            <a
              href={item.path}
              key={item.primary}
              style={{
                textDecoration: "none",
                color: "green",
                padding: "0.4rem",
                borderRadius: "4px",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  width: "24px",
                  height: "24px",
                  // filter: location.pathname.startsWith(
                  //   item.path.match(/^\/[^/]+/)[0]
                  // )
                  //   ? "invert(1)"
                  //   : "invert(0)",
                }}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    ));
  };

  const renderSecondarySidebarItems = (elements, heading) => {
    return (
      <div style={{ width: "100%", fontFamily: "Inter", marginTop: "1.5rem" }}>
        {heading && (
          <p
            style={{
              color: "#fff",
              fontWeight: "700",
              fontSize: "24px",
              padding: "0 2rem 0 0.5rem",
              marginLeft: "1rem",
              borderBottom: "2px solid #fff",
              display: "inline-block",
            }}
          >
            {heading}
          </p>
        )}
        {elements.map((item, index) => {
          const isChildSelected =
            item.children &&
            item.children.some((child) => location.pathname === child.path);

          return item.heading ? (
            <p
              key={`heading-${index}`}
              style={{
                color: "rgba(255, 255, 255, 1)",
                paddingLeft: "1rem",
                marginBottom: "0.5rem",
                marginTop: "1rem",
                fontFamily: "Public Sans",
                fontSize: "11px",
                fontWeight: 400,
                lineHeight: "14px",
              }}
            >
              {item.heading}
            </p>
          ) : (
            <div key={`item-${index}`}>
              <Link
                to={item.path}
                onClick={(e) => {
                  if (item.children) {
                    e.preventDefault();
                    handleClick(item, index);
                  } else {
                    // navigate(item.path);
                  }
                }}
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname === item.path || isChildSelected
                      ? "#488257"
                      : "#ffffff",
                  display: "flex",
                  padding: "0.5rem",
                  margin: "4px 8px",
                  backgroundColor:
                    location.pathname === item.path || isChildSelected
                      ? "#ffffff"
                      : "transparent",
                  borderRadius: "4px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Box
                  component="img"
                  src={item.icon}
                  alt={"img"}
                  sx={{
                    filter:
                      location.pathname === item.path || isChildSelected
                        ? "invert(32%) sepia(23%) saturate(900%) hue-rotate(90deg) brightness(60%) contrast(90%)"
                        : "invert(0)",
                  }}
                />
                <span
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "inherit",
                  }}
                >
                  {item.text}
                </span>
                {item.children && (
                  <span style={{ marginLeft: "auto", fontSize: "16px" }}>
                    {open?.header === item.text ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </span>
                )}
              </Link>
              {item.children && open?.header === item.text && (
                <div style={{ paddingLeft: "0.5rem" }}>
                  {item.children.map((child, childIndex) => (
                    <Link
                      key={`child-${childIndex}`}
                      to={child.path}
                      onClick={(e) => {
                        // navigate(child.path);
                      }}
                      style={{
                        textDecoration: "none",
                        color: "#ffffff",
                        display: "flex",
                        padding: "0.5rem 0 0.5rem 0.5rem",
                        margin: "4px 8px",
                        borderRadius: "4px",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {location.pathname === child.path ? (
                        <CheckCircleOutlineIcon
                          style={{
                            width: "16px",
                          }}
                        />
                      ) : (
                        <RadioButtonUncheckedIcon
                          style={{
                            width: "16px",
                          }}
                        />
                      )}
                      <span
                        style={{
                          marginLeft: "0.5rem",
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "inherit",
                        }}
                      >
                        {child.text}
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Box style={{ display: "flex", overflow: "hidden", width: "100%", height: "100vh" }}>
        <div
          style={{
            width: "22.5%",
            height: "100vh",
            backgroundColor: "#E6E6E6",
            position: "relative",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Box display="flex" justifyContent="center" py={1}>
            <img
              src={NirantaraIcon}
              alt="Nirantara Logo"
              style={{ cursor: "pointer", height: "36px", width: "36px" }}
              onClick={() => navigate("/dashboard")}
            />
          </Box>
          <div style={{ width: "100%", marginTop: "1rem" }}>
            {renderMainSidebarItems(miniSidebarFiltered)}
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "21.3vw",
              height: "100vh",
              backgroundColor: "#fff",
              zIndex: 10,
              overflowY: "auto",
              transform: isHovered ? "translateX(0)" : "translateX(-100%)",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.4s ease, transform 0.4s ease",
              pointerEvents: isHovered ? "auto" : "none",
              willChange: "transform, opacity",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {<SidebarItemsRenderer elements={filteredSidebar} />}
          </div>
        </div>
        <div
          ref={sidebarRef}
          style={{
            backgroundColor: "rgba(72, 130, 87, 1)",
            width: "77.5%",
            overflowY: "auto",
            height: "100vh",
          }}
        >
          {renderSecondarySidebarItems(
            filteredScope3MastersSidebarElements,
            "Scope 3",
          )}
        </div>
      </Box>
    </>
  );
};

export default Scope3Layout;
